// PMax Brand Guidelines — Creative Excellence section, deterministic check.
// Per-campaign established/missing, campaigns missing guidelines first.

import type { EvidenceProps } from './registry';

interface CampaignRow {
  id?: string;
  name: string;
  brandGuidelinesEnabled: boolean;
}

interface BrandGuidelinesShape {
  totalCampaigns: number;
  enabledCount: number;
  missingCount: number;
  campaigns: CampaignRow[];
}

export const PmaxBrandGuidelinesEvidence = ({ evidence }: EvidenceProps) => {
  const e = evidence as unknown as BrandGuidelinesShape;

  return (
    <div className='evidence'>
      <section className='evidence__section'>
        <h4 className='evidence__section-title'>
          Brand Guidelines
          <span className='evidence__section-tag evidence__section-tag--context'>
            {e.totalCampaigns} PMax campaigns
          </span>
        </h4>
        <div className='audience-coverage'>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.enabledCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>Established</div>
          </div>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.missingCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>Missing</div>
          </div>
        </div>
      </section>

      <section className='evidence__section'>
        <h4 className='evidence__section-title'>Per-campaign setting</h4>
        <table className='evidence__table evidence__table--pmax-final-url'>
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Brand Guidelines</th>
            </tr>
          </thead>
          <tbody>
            {e.campaigns.map(c => (
              <tr key={c.id ?? c.name}>
                <td>{c.name}</td>
                <td>
                  <span
                    className={`evidence__strength ${
                      c.brandGuidelinesEnabled
                        ? 'evidence__strength--good'
                        : 'evidence__strength--average'
                    }`}
                  >
                    {c.brandGuidelinesEnabled ? 'Established' : 'Missing'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <p className='evidence__footnote'>
        Brand Guidelines (brand font, primary/secondary colors, business name, logo) are a
        per-campaign guardrail governing how the brand appears in Performance Max's automated assets
        and formats. Tinuiti recommends establishing them in every PMax campaign for consistent
        brand representation.
      </p>
    </div>
  );
};
